import React, { useState, useEffect } from "react";
//import axios from "axios";
import api from '../../utils/api';
import { Link } from "react-router-dom";

//import CloseIcon from "@mui/icons-material/Close";
import {API_BASE}from '../../utils/api';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useRestaurantConfig } from "../../utils/restaurantConfig";
import { getCurrencySymbol } from "../../helper/formatCurrency";
const OrderDetails = () => {
  const { locale } = useRestaurantConfig();
  const currencySymbol = getCurrencySymbol(locale);
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [statusHistory, setStatusHistory] = useState([]);
  const [address, setAddress] = useState('');
  const [showAddRow, setShowAddRow] = useState(false); 
const [selectedProductId, setSelectedProductId] = useState(""); 
const [selectedProduct, setSelectedProduct] = useState(null);
const [quantity, setQuantity] = useState(1); 
const [driverName, setDriverName] = useState("");
const [driverMobile, setDriverMobile] = useState("");
const [driverList, setDriverList] = useState([]);
const [useNewDriver, setUseNewDriver] = useState(false);
const [driverId, setDriverId] = useState("");
const [rows, setRows] = useState(selectedOrder?.products || []);
const [showSubmitButton, setShowSubmitButton] = useState(false);
const [suggestions, setSuggestions] = useState([]);
const [deleteIndex, setDeleteIndex] = useState(null);

const [selectedDrivers, setSelectedDrivers] = useState({});

const [showDeletePopup, setShowDeletePopup] = useState(false);
//const [showReasonDropdown, setShowReasonDropdown] = useState(null);
const [selectedReasons, setSelectedReasons] = useState({});
const [addressOptions, setAddressOptions] = useState([]);
const [isLoadingOrders, setIsLoadingOrders] = useState(false);
//const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
//const [isFetchingAddress, setIsFetchingAddress] = useState(false);
const [expandedOrderIds, setExpandedOrderIds] = useState(new Set());
 const [addresses, setAddresses] = useState({});


//const [selectedAddresses, setSelectedAddresses] = useState({}); // { orderId: selectedAddress }

  const toggleExpand = (orderId) => {
    setExpandedOrderIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(orderId)) {
        newSet.delete(orderId);
      } else {
        newSet.add(orderId);
      }
      return newSet;
    });
  };
const statusColors = {
  pending: "#FFEB3B",              
  accept: "#4CAF50",              
  reject: "#F44336",               
  "ready for delivery": "#009688",
  "delivery pickup": "#00BCD4",    
  "out for delivery": "#FF9800",  
  completed: "#388E3C",            
  cancelled: "#9E9E9E",            
  processing: "#FFC107"            
};

const handleAddressChange = (orderId, newAddress) => {
  setAddresses((prev) => ({
    ...prev,
    [orderId]: newAddress,
  }));
};

const reasons = [
  "Out of Stock",
  "Not Deliverable to Location",
  "Cancelled by Admin",
  "Pricing Error"
];

useEffect(() => {
  

  fetchDrivers();
}, []);
const fetchDrivers = async () => {
    try {
      //const response = await axios.get(`${API_BASE}/api/orders/drivers`);
        const response = await api.get(`/orders/drivers`);

      setDriverList(response.data);
    } catch (error) {
      console.error("Driver fetch error:", error);
    }
  };
  useEffect(() => {
    if (selectedOrder) {
      fetchStatusHistory(selectedOrder._id);
      setAddress(selectedOrder.address || "");
      fetchDrivers();
    }
  }, [selectedOrder]);
  
  const [selectedSort, setSelectedSort] = useState("");
  const statusBlockStyle = (status) => ({
    padding: "10px 20px",
    backgroundColor: selectedSort === status ? "#f9d59b" : "#c484f3", 
    color: selectedSort === status ? "white" : "white",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    height: "80px",
    width: "130px",
 
    transition: "background-color 0.3s",
    display: "flex",                  
    justifyContent: "center",         
    alignItems: "center",             
    textAlign: "center",             
  });
  const handleStatusClick = (status) => {
  if (selectedSort === status) {
   
    setSelectedSort("");
  } else {
    
    setSelectedSort(status);
  }
};
useEffect(() => {
  if (selectedOrder?.phoneNumber) {
    fetch(`${API_BASE}/api/orders/by-phone/${selectedOrder.phoneNumber}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched orders:", data); 

        let ordersArray = [];
        if (Array.isArray(data)) {
          ordersArray = data;
        } else if (data && typeof data === 'object') {
          ordersArray = [data];
        }

        const uniqueAddresses = [...new Set(
          ordersArray.map(order => order.address).filter(Boolean)
        )];
        
        setAddressOptions(uniqueAddresses);
        setAddress(uniqueAddresses[0] || '');
      })
      .catch((err) => console.error("Failed to fetch address options:", err));
  }
}, [selectedOrder]);


  const fetchStatusHistory = async (orderId) => {
    try {
     // const response = await axios.get(`${API_BASE}/api/orders/statusHistory/${orderId}`);
      const response = await api.get(`/orders/statusHistory/${orderId}`);

      setStatusHistory(response.data);
      console.log(response);
    } catch (error) {
      console.error("Error fetching status history:", error);
    }
  };
  const statusList = ["placed", "accepted", "dispatched", "delivered"];
const currentStatusIndex = statusList.findIndex(
  s => s === orders.currentStatus
);

  const fetchOrders = async () => {
    setIsLoadingOrders(true);
    try {
     // const response = await axios.get(`${API_BASE}/api/orders/all`);
      const response = await api.get(`/orders/all`);
    
      const ordersData = response.data;

      const enrichedOrders = await Promise.all(
        ordersData.map(async (order) => {
          try {
            const res = await fetch(`${API_BASE}/api/orders/by-phone/${order.phoneNumber}`);
            const data = await res.json();

            let ordersArray = Array.isArray(data) ? data : [data];
            const uniqueAddresses = [...new Set(
              ordersArray.map(o => o.address).filter(Boolean)
            )];

            return {
              ...order,
              addressOptions: uniqueAddresses,
            };
          } catch (err) {
            console.error(`Failed fetching address options for ${order.phoneNumber}`, err);
            return {
              ...order,
              addressOptions: [],
            };
          }
        })
      );

      setOrders(enrichedOrders);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setIsLoadingOrders(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);
  const statusFlow = {
    pending: ["accept", "reject"],
    accept: ["delivery pickup"],
    "delivery pickup": ["out for delivery"],
   // "delivery pickup": ["out for delivery"],
    "out for delivery": ["completed"],
    completed: []  
  };
  
  const getCountByStatus = (status) => {
    return orders.filter(order => order.status === status).length;
  };
  
  
  const statusPriority = [
    "pending",
    "accept",
    "ready for delivery",
    "delivery pickup",
    "out for delivery",
    "completed"
  ];
  useEffect(() => {
    if (selectedOrder && selectedOrder.products) {
      setRows(selectedOrder.products);
    }
  }, [selectedOrder]);
  const filteredOrders = orders.filter((order) => {
    const matchesSearch =
      order.orderId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.phoneNumber.includes(searchTerm) ||
      order.status.toLowerCase().includes(searchTerm.toLowerCase());
  
    const matchesStatus =
      !selectedSort || order.status.toLowerCase() === selectedSort.toLowerCase();
  
    return matchesSearch && matchesStatus;
  });
  
  const sortedOrders = [...filteredOrders].sort(
    (a, b) =>
      statusPriority.indexOf(a.status.toLowerCase()) -
      statusPriority.indexOf(b.status.toLowerCase())
  );
  
  
  const getNextStatuses = (currentStatus) => statusFlow[currentStatus] || [];

  const updateOrderStatus = async () => {
    if (!selectedOrder) return;
  
    if ((newStatus || selectedOrder.status) === "accept" && (!address || address.trim() === "")) {
      toast.error("Cannot accept order without an address.");
      return;
    }
  
    try {
      let finalDriverId = driverId;  

if ((newStatus || selectedOrder.status) === "delivery pickup") {
  
  if (!finalDriverId && (!driverName.trim() || !driverMobile.trim())) {
    toast.warn("Please enter driver name and mobile number.");
    return;
  }

  
  if (!finalDriverId && driverName.trim() && driverMobile.trim()) {
    //const driverRes = await axios.post(`${API_BASE}/api/orders/add`, {
    const driverRes = await api.post(`/orders/add`, {

      name: driverName.trim(),
      mobileNumber: driverMobile.trim(),
      isActive: true,
    });
    finalDriverId = driverRes.data._id;
  }
}

//await axios.put(`${API_BASE}/api/orders/updateStatus/${selectedOrder.orderId}`, {
 await api.put(`/orders/updateStatus/${selectedOrder.orderId}`, {
status: newStatus,
  address: address || null,
  assignedDriver: finalDriverId || null, 
});

  
      toast.success("Order status updated successfully!");
      fetchOrders();
      setSelectedOrder(null);
    } catch (error) {
      console.error("Error updating order status:", error);
      toast.error("Failed to update order status.");
    }
  };
  
  const handleAddProduct = async () => {
    if (!selectedProduct || quantity < 1) {
      toast.error("Please select a product and enter a valid quantity.");
      return;
    }
  
    const newProduct = {
      _id: selectedProduct._id,
      productTitle: selectedProduct.title,
      quantity,
      price: selectedProduct.price,
    };
  
    
    setSelectedOrder((prevOrder) => ({
      ...prevOrder,
      products: [...prevOrder.products, newProduct], 
    }));
  
    
    //await axios.put(`${API_BASE}/api/orders/updateOrder/${selectedOrder._id}`, {
    await api.put(`/orders/updateOrder/${selectedOrder._id}`, {
      products: [...selectedOrder.products, newProduct],
    });
  
 
    setSelectedProductId("");
    setSelectedProduct(null);
    setQuantity(1);
    setShowAddRow(false); 
    toast.success("Product added to the order!");
  };
  
  const handleAddRow = () => {
    setRows((prev) => [
      ...prev,
      {
        _id: Date.now(),
        productTitle: "",
        quantity: 1,
        price: 0,
        isNew: true,
      },
    ]);
    setShowSubmitButton(true); 
  };

  const handleChange = async (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  
    if (field === "productTitle" && value.length > 2) {  
      try {
        //const res = await axios.get(`${API_BASE}/api/products/search?query=${value}`);
          const res = await api.get(`/products/search?query=${value}`);

        setSuggestions(res.data); 
        console.log(res);
      } catch (err) {
        console.error("Error fetching suggestions", err);
      }
    } else {
      setSuggestions([]);
    }
  };
  
  const handleSelectSuggestion = (index, product) => {
    const updated = [...rows];
    updated[index].productTitle = product.productName;  
    updated[index].price = product.price;  
    setRows(updated);
    setSuggestions([]); 
  };
  
  
  const handleSubmit = async () => {
    const newItems = rows.filter((row) => row.isNew);
  
    const cleanedItems = newItems.map((item) => ({
      productId: item._id, // remap
      productTitle: item.productTitle,
      quantity: parseInt(item.quantity),
      price: parseFloat(item.price),
      subTotal: parseFloat(item.price) * parseInt(item.quantity),
      orderStatus: item.orderStatus || "",
      isAdmin: true
    }));
  
    //console.log("Final cleaned items to send:", cleanedItems);
  
    try {
      //const response = await axios.put(
        const response = await api.put(

        `/orders/${selectedOrder.orderId}/admin-update`,
        { updatedProducts: cleanedItems }
      );
      toast.success("Order updated successfully by admin!");
      setShowSubmitButton(false);
    } catch (error) {
      console.error("Error updating order:", error);
      toast.error("Failed to update order. Please try again.");
    }
  };
  const handleProductDelete = async (index) => {
    const product = rows[index]; 
    const reason = selectedReasons[index]; 
  
    if (!reason) {
      toast.error("Please select a reason before confirming the deletion.");
      return;
    }
    //console.log("Product:", product);
//console.log("Product ID:", product._id);

  
    try {
     // const response = await axios.put(
     const response = await api.put(
        `/orders/${selectedOrder.orderId}/remove-product`,
        {
          productId: product.productId, 
          reason
        }
      );
      toast.success("Product removed successfully!");
  
      // Remove 
      setRows(prevRows => prevRows.filter(p => p._id !== product._id));
    } catch (error) {
      console.error("Error removing product:", error);
      toast.error("Failed to remove product.");
    }
  };
  
  return (
    <div style={{ fontFamily: "Roboto" }}>
      <ToastContainer position="top-center" autoClose={1000} />
      {selectedOrder ? (
  <div style={{ padding: "20px" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
    <IconButton
      onClick={() => setSelectedOrder(null)}
      className="back-button"
      style={{
        backgroundColor: '#e0e0e0',
        border: '1px solid #ccc',
        borderRadius: '50%',
        padding: '5px',
        color: '#333',
      }}
    >
      <KeyboardBackspaceIcon fontSize="medium" />
    </IconButton>
    <h5 className="heading">Order Details</h5>
  </div>


  <p><strong>Order ID:</strong> {selectedOrder.orderId}</p>

<p><strong>Phone Number:</strong> {selectedOrder.phoneNumber}</p>
{/*<div style={{ marginBottom: '1rem' }}>
  <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', fontSize: '16px' }}>
    Select Address:
  </label>
  <select
    value={address}
    onChange={(e) => setAddress(e.target.value)}
    style={{
      width: '28%',
      padding: '10px',
      border: '1px solid #ccc',
      borderRadius: '6px',
      fontSize: '15px',
      backgroundColor: '#ffff',
      cursor: 'pointer',
      transition: 'border-color 0.3s ease'
    }}
  >
    {addressOptions.length === 0 ? (
      <option value="">None</option>
    ) : (
      addressOptions.map((addr, index) => (
        <option key={index} value={addr}>
          {addr}
        </option>
      ))
    )}
  </select>
</div>
<p></p>
<textarea
  id="address"
  name="address"
  rows="4"
  cols="50"
  value={address}
  onChange={(e) => setAddress(e.target.value)} 
  placeholder="Enter your full address"
  required
/>
*/}

<div style={{ maxHeight: "55vh", overflowY: "auto", padding: "20px",scrollbarWidth:"none"}}>
    <table style={{ width: "50%", borderCollapse: "collapse",overflow:"auto",backgroundColor:"white",padding:"20px"}}>
   
      <thead>
        <tr>
        
          <th style={{ padding: "8px", border: "1px solid #ddd" }}>Product</th>
          <th style={{ padding: "8px", border: "1px solid #ddd" }}>Quantity</th>
          <th style={{ padding: "8px", border: "1px solid #ddd" }}>Price</th>
          <th style={{ padding: "8px", border: "1px solid #ddd" }}>TotalPrice</th>
          <th style={{ padding: "8px", border: "1px solid #ddd" }}>Actions</th>
        </tr>
      </thead>
      <tbody>
          {rows.map((product, index) => (
            <tr key={product._id}>
              <td style={{border: "1px solid #ddd", }}>
  {product.isNew ? (
    <>
      <input
  type="text"
  value={product.productTitle}
  onChange={(e) => {
    console.log("Input changed:", e.target.value);  
    handleChange(index, "productTitle", e.target.value);
  }}
  autoComplete="off"
/>
{index === rows.length - 1 && suggestions.length > 0 && (
  <ul
    style={{
      listStyle: "none",
      margin: 0,
      padding: "5px",
      border: "1px solid #ccc",
      backgroundColor: "white",
      position: "absolute",
      width: "10%",
      zIndex: 10,
      maxHeight: "150px",
      overflowY: "auto",
      overflowX: "auto",
    }}
  >
    {suggestions.map((item) => (
      <li
        key={item._id}
        onClick={() => handleSelectSuggestion(index, item)}
        style={{cursor: "pointer",fontSize:"14px" }}
      >
        {item.productName} 
      </li>
    ))}
  </ul>
)}


    </>
  ) : (
    product.productTitle.split(",")[0]
  )}
</td>

              <td style={{border: "1px solid #ddd",padding:"8px" }}>
                {product.isNew ? (
                  <input
                    type="number"
                    value={product.quantity}
                    onChange={(e) => handleChange(index, "quantity", e.target.value)}
                  />
                ) : (
                  product.quantity
                )}
              </td>
             <td style={{ border: "1px solid #ddd" }}>
  {product.isNew ? (
    <input
      type="number"
      value={product.price}
      readOnly
      style={{
        fontFamily: "Segoe UI Symbol, Arial, sans-serif",
        backgroundColor: "#f9f9f9", 
        cursor: "not-allowed",
      }}
    />
  ) : (
    `${currencySymbol}${product.price}`
  )}
</td>

<td style={{border: "1px solid #ddd"}}>
  {currencySymbol}
  {(product.quantity * product.price).toFixed(2)}
</td>
<td style={{ border: "1px solid #ddd", position: "relative" }}>
  {!product.isNew && product.active !== false && (
    <>
      <IconButton
        onClick={() => {
          setDeleteIndex(index);
          setShowDeletePopup(true);
        }}
        style={{
          color: "red",
          fontSize: "2px",
        }}
        title="Delete product"
      >
        <DeleteIcon />
      </IconButton>
    </>
  )}
</td>
{showDeletePopup && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999,
    }}
  >
    <div
      style={{
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        width: "300px",
        textAlign: "center",
      }}
    >
      <h4>Delete Product</h4>
      <p>Please select a reason:</p>
      <select
        value={selectedReasons[deleteIndex] || ""}
        onChange={(e) =>
          setSelectedReasons((prev) => ({
            ...prev,
            [deleteIndex]: e.target.value,
          }))
        }
        style={{
          width: "100%",
          marginBottom: "10px",
          padding: "5px",
        }}
      >
        <option value="">Select Reason</option>
        {reasons.map((reason, i) => (
          <option key={i} value={reason}>
            {reason}
          </option>
        ))}
      </select>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button
          onClick={() => setShowDeletePopup(false)}
          style={{
            padding: "5px 10px",
            backgroundColor: "#ccc",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>

        <button
          onClick={() => {
            handleProductDelete(deleteIndex);
            setShowDeletePopup(false);
          }}
          style={{
            padding: "5px 10px",
            backgroundColor: "red",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Confirm Delete
        </button>
      </div>
    </div>
  </div>
)}

            </tr>
          ))}
            {selectedOrder?.status === "pending" && (

  <tr>
    <td colSpan="3" style={{ textAlign: "center", padding: "10px" }}>
      <span
        onClick={handleAddRow}
        style={{
          fontSize: "14px",
          cursor: "pointer",
          color: "#007bff",
          userSelect: "none",
        }}
      >
        Add Item
      </span>
    </td>
  </tr>
)}

          {showSubmitButton && (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", padding: "10px" }}>
                <button
                  onClick={handleSubmit}
                  style={{
                    padding: "8px 16px",
                    fontSize: "16px",
                    backgroundColor: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Submit
                </button>
              </td>
            </tr>
          )}
        </tbody>
    </table> 
{selectedOrder.status !== "completed"&& selectedOrder.status !== "reject" && (
  <>
    <label style={{ display: "block", marginTop: "10px", marginBottom: "5px" }}>
      <strong>Update Status:</strong>
    </label>

    <div style={{ display: "flex", alignItems: "center", gap: "15px", flexWrap: "wrap" }}>
   
      {getNextStatuses(selectedOrder.status).length > 0 &&
        getNextStatuses(selectedOrder.status).map((status) => (
          <button
            key={status}
            onClick={async () => {
              setNewStatus(status);

              if (status === "accept" && (!address || address.trim() === "")) {
                toast.error("Cannot accept order without an address.");
                return;
              }

              let finalDriverId = driverId;

              if (status === "delivery pickup") {
                if (!finalDriverId && (!driverName.trim() || !driverMobile.trim())) {
                  toast.error("Please enter driver name and mobile number.");
                  return;
                }

                if (!finalDriverId && driverName.trim() && driverMobile.trim()) {
                  try {
                  //  const driverRes = await axios.post(`${API_BASE}/api/orders/add`, {
                  const driverRes = await api.post(`/orders/add`, {
                      name: driverName.trim(),
                      mobileNumber: driverMobile.trim(),
                      isActive: true,
                    });
                    finalDriverId = driverRes.data._id;
                  } catch (err) {
                    console.error("Failed to add driver:", err);
                    toast.error("Error adding driver.");
                    return;
                  }
                }
              }

              try {
                //await axios.put(`${API_BASE}/api/orders/updateStatus/${selectedOrder.orderId}`, {
                  await api.put(`/orders/updateStatus/${selectedOrder.orderId}`, {
                  status,
                  address: address || null,
                  assignedDriver: finalDriverId || null,
                });

                toast.success("Order status updated successfully!");
                fetchOrders();
                setSelectedOrder(null);
              } catch (error) {
                console.error("Error updating order status:", error);
                toast.error("Failed to update order status.");
              }
            }}
            style={{
              padding: "6px 12px",
              backgroundColor: newStatus === status ? "#4CAF50" : "#1976d2",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </button>
        ))}

      {newStatus === "delivery pickup" && selectedOrder.status !== "delivery pickup" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%" }}>
          {!useNewDriver ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <select
                value={driverId}
                onChange={(e) => setDriverId(e.target.value)}
                style={{ padding: "5px", width: "40%" }}
              >
                <option value="">Select Driver</option>
                {driverList.map((driver) => (
                  <option key={driver._id} value={driver._id}>
                    {driver.name} - {driver.mobile}
                  </option>
                ))}
              </select>

              <button
                type="button"
                onClick={() => setUseNewDriver(true)}
                style={{
                  padding: "4px 10px",
                  fontWeight: "bold",
                  cursor: "pointer"
                }}
              >
                +
              </button>
            </div>
          ) : (
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <input
                type="text"
                placeholder="Driver Name"
                value={driverName}
                onChange={(e) => setDriverName(e.target.value)}
                style={{ padding: "5px", width: "40%" }}
              />
              <input
                type="text"
                placeholder="Mobile Number"
                value={driverMobile}
                onChange={(e) => setDriverMobile(e.target.value)}
                style={{ padding: "5px", width: "40%" }}
              />
              <button
                type="button"
                onClick={() => setUseNewDriver(false)}
                style={{ padding: "4px 10px", fontWeight: "bold", cursor: "pointer" }}
              >
                Cancel
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  </>
)}


<div style={{ marginTop: "10px" }}>
  <h3>Order Status History</h3>
  <table style={{ width: "50%", borderCollapse: "collapse", backgroundColor: "white" }}>
    <thead>
      <tr>
        <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "left" }}>Status</th>
    <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "left" }}>Updated At</th>
        <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "left" }}>Time Taken</th>
      </tr>
    </thead>
    <tbody>
      {statusHistory.length > 0 ? (
        statusHistory.map((history, index) => {
          let timeSpent = "--";
          if (index > 0) {
            const current = new Date(history.createdAt);
            const previous = new Date(statusHistory[index - 1].createdAt);
            const diffMs = current - previous;
            const totalSeconds = Math.floor(diffMs / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            timeSpent = `${hours}h ${minutes}m ${seconds}s`;
          }

          const formattedUpdatedAt = new Date(history.updatedAt).toLocaleString();

          return (
            <tr key={history._id}>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {history.status.charAt(0).toUpperCase() + history.status.slice(1)}
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>{formattedUpdatedAt}</td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>{timeSpent}</td>
            
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan="3" style={{ padding: "8px", textAlign: "center" }}>No status history available</td>
        </tr>
      )}
    </tbody>
  </table>

    </div>
    
</div>
  </div>
) : (
  <>
    <div>
  <h1>Order Details</h1>
  <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "15px" }}>
    <div onClick={() => handleStatusClick("pending")} style={statusBlockStyle("pending")}>
      Pending ({getCountByStatus("pending")})
    </div>
    <div onClick={() => handleStatusClick("accept")} style={statusBlockStyle("accept")}>
      Accept ({getCountByStatus("accept")})
    </div>
    {/*<div onClick={() => handleStatusClick("ready for delivery")} style={statusBlockStyle("ready for delivery")}>
      Ready for Delivery ({getCountByStatus("ready for delivery")})
    </div>*/}
    <div onClick={() => handleStatusClick("delivery pickup")} style={statusBlockStyle("delivery pickup")}>
      Delivery Pickup ({getCountByStatus("delivery pickup")})
    </div>
    <div onClick={() => handleStatusClick("out for delivery")} style={statusBlockStyle("out for delivery")}>
      Out for Delivery ({getCountByStatus("out for delivery")})
    </div>
    {/*<div onClick={() => handleStatusClick("completed")} style={statusBlockStyle("completed")}>
      Completed ({getCountByStatus("completed")})
    </div>*/}
  </div>

  <div style={{ display: "flex", alignItems: "center" }}>
    <input
      type="text"
      placeholder="Search orders..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      style={{
        width: "20%",
        padding: "8px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        fontSize: "16px",
        marginRight: "20px",
      }}
    />
  </div>

  
 <div style={{ maxHeight: "65vh", overflowY: "auto", marginTop: 10 }}>
      {isLoadingOrders ? (
        <div style={{ textAlign: "center", padding: 20 }}>
          <div className="spinner"></div>
        </div>
      ) : sortedOrders.length === 0 ? (
        <div style={{ textAlign: "center", padding: 20 }}>No orders found.</div>
      ) : (
        sortedOrders
          .filter((order) => order.products && order.products.length > 0)
          .map((order, index) => {
            const createdTime = new Date(order.createdAt);
            const now = new Date();
            const diffMinutes = (now - createdTime) / (1000 * 60);
            const showWarning = order.status !== "completed" && diffMinutes > 30;

            const isExpanded = expandedOrderIds.has(order._id);

            return (
             
  <div
    key={order._id}
    style={{
      marginBottom: 16,
      padding: 16,
      backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
      borderRadius: 8,
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      userSelect: "none",
    }}
  >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <div style={{ fontWeight: "bold", fontSize: 16 }}>
                    Order ID: {order.orderId}{" "}
                    {showWarning && (
                      <span
                        style={{
                          color: "red",
                          marginLeft: 8,
                          fontWeight: "bold",
                          fontSize: 18,
                        }}
                        title="Order delayed"
                      >
                        ⚠
                      </span>
                    )}
                  </div>

                 <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 6 }}>
  <span
    style={{
      padding: "4px 12px",
      borderRadius: 20,
      color: "white",
      backgroundColor:
        statusColors[order.status.toLowerCase()] || "gray",
      textTransform: "capitalize",
      fontWeight: "600",
      fontSize: 14,
      userSelect: "none",
      display: "inline-block",
    }}
  >
    {order.status}
  </span>
<Link
  to="#"
  onClick={(e) => {
    e.preventDefault();
    setSelectedOrder(order);
    setNewStatus(order.status);
  }}
  style={{
    color: "#007bff",          
    cursor: "pointer",
    fontSize: 14,
    textDecoration: "underline",  
    marginTop: "12px",
    marginBottom: "4px",
    display: "inline-block",
  }}
>
  Details
</Link>

</div>

                </div>

             <div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "8px",               
    marginBottom: 8,
  }}
>
  <div>
    <strong>Phone Number:</strong> {order.phoneNumber}
  </div>
  {order.status !== "pending" && (
  <div>
    <strong>Address:</strong> {order.address || "N/A"}
  </div>
)}

  <div>
    <strong>Total Price:</strong> {currencySymbol}
    {order.amount}
  </div>
  {order.status !== "pending" && order.status !== "accept" && (
  <div>
    <strong>Delivery:</strong>{" "}
    {order.assignedDriver?.name || "N/A"}
  </div>
)}

</div>

                <div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleExpand(order._id);
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#007bff",
                      cursor: "pointer",
                      padding: 0,
                      fontSize: 14,
                      marginBottom: 8,
                      userSelect: "none",
                    }}
                  >
                    {isExpanded ? "Hide Products ▲" : "Show Products ▼"}
                  </button>

               {isExpanded && (
  <ul
    style={{
      maxHeight: 150,
      overflowY: "auto",
      paddingLeft: 20,
      marginTop: 8,
      border: "1px solid #ddd",
      borderRadius: 6,
      backgroundColor: "#fff",
    }}
  >
    {order.products.map((p, idx) => (
      <li
        key={idx}
        style={{
          marginBottom: 6,
          whiteSpace: "normal",
          wordBreak: "break-word",
          color: p.active ? "#000" : "red",
        }}
      >
        {p.productTitle.split(",")[0]} (Qty:{p.quantity})
        {!p.active && (
          <span style={{ fontStyle: "italic", marginLeft: 4 }}>
          
          </span>
        )}
      </li>
    ))}
  </ul>
)}
{order.status === "accept" && (
  <div style={{ marginBottom: 12 }}>
    <label style={{ fontWeight: 'bold' }}>Assign Driver:</label>
    <select
      value={selectedDrivers[order._id] || ""}
      onChange={(e) => {
        const driverId = e.target.value;
        setSelectedDrivers(prev => ({ ...prev, [order._id]: driverId }));
      }}
      style={{
        width: '150px',
        padding: '10px',
        marginTop: '8px',
        borderRadius: '6px',
        border: '1px solid #ccc',
      }}
    >
      <option value="">-- Select Driver --</option>
      {driverList
        .filter(driver => driver.isActive)
        .map(driver => (
          <option key={driver._id} value={driver._id}>
            {driver.name} ({driver.mobile})
          </option>
        ))}
    </select>
  </div>
)}

{order.status === "pending" && (
  <div style={{ marginBottom: '1rem' }}>
    <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '0.5rem', fontSize: '16px' }}>
      Select Address:
    </label>

    <select
      value={addresses[order._id] || ""}
      onChange={(e) => handleAddressChange(order._id, e.target.value)}
      style={{
        width: '180px',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '6px',
        fontSize: '15px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        transition: 'border-color 0.3s ease'
      }}
    >
      <option value="">-- Select an address --</option>
      {order.addressOptions?.map((addr, index) => (
        <option key={index} value={addr}>
          {addr}
        </option>
      ))}
    </select>

    <p></p>

    <textarea
      id={`address-${order._id}`}
      name={`address-${order._id}`}
      rows="4"
      cols="50"
      value={addresses[order._id] || ""}
      onChange={(e) => handleAddressChange(order._id, e.target.value)}
      placeholder="Enter your full address"
      required
      style={{
        width: '150px',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '6px',
        fontSize: '15px',
        //marginTop: '10px',
        resize: 'vertical',
      }}
    />
  </div>
)}




                </div>
                <div style={{ marginTop: 12 }}>
                <strong>Update Status:</strong>
                <div
                  style={{
                    display: "flex",
                    gap: "2px",
                    flexWrap: "wrap",
                    marginTop: 6,
                  }}
                >
                   {getNextStatuses(order.status).length === 0 ? (
      <>
        <span
          style={{
            padding: "6px 12px",
            backgroundColor: "#888",
            color: "white",
            borderRadius: 4,
            fontSize: 14,
            textTransform: "capitalize",
          }}
        >
          {order.status}
        </span>
       
      </>
    ) : (
                    getNextStatuses(order.status).map((status) => (
                      <button
                     onClick={async () => {
  const rawAddress = addresses[order._id];
  const address = typeof rawAddress === "string" ? rawAddress.trim() : "";

  if (order.status === "pending" && !address) {
    toast.warn("Please select an address.");
    return;
  }

  if (status === "delivery pickup" && !selectedDrivers[order._id]) {
    toast.warn("Please select a driver before proceeding.");
    return;
  }

  try {
   // await axios.put(`${API_BASE}/api/orders/updateStatus/${order.orderId}`, {
       await api.put(`/orders/updateStatus/${order.orderId}`, {
  status,
  address,
  assignedDriverName: selectedDrivers?.name || "", 
});


    toast.success(`Order status updated to "${status}" successfully!`);
    fetchOrders();
  } catch (error) {
    console.error("Error updating order status:", error);
    toast.error("Failed to update order status.");
  }
}}

                        style={{
                          padding: "6px 12px",
                          backgroundColor: "#1976d2",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          textTransform: "capitalize",
                        }}
                      >
                        {status}
                      </button>
                      
                    ))
                  )}
                </div>
              </div>
            </div>
          );
        })
    )}
  </div>

      
      



    
  </div>
  </>
)}

    </div>
  );
  

};

export default OrderDetails;






